import React from 'react';
import classNames from 'classnames';
import Tappable from 'app/components/commons/Tappable';
import * as cssUtils from 'app/utils/cssUtils';
import useSheet from 'app/jss';
import { get, noop } from 'lodash';

type Props = {
  classes: object,
  children: any,
  onClick: (...args) => void,
  isActive?: boolean,
  disabled?: boolean,
};

type State = {};

class GroupContainerCategoryItem extends React.Component {
  props: Props;
  state: State = {};

  static defaultProps = {
    children: undefined,
    isActive: false,
    onClick: undefined,
    isDisabled: false,
  };

  render() {
    const {
      classes,
      children,
      isActive,
      disabled,
      onClick,
    } = this.props;

    return (
      <Tappable
        className={classNames(classes.friendCategory, { active: isActive, disabled })}
        onTap={disabled ? noop : onClick}
      >
        {children}
      </Tappable>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    friendCategory: {
      fontSize: 14,
      fontWeight: 600,
      color: theme.color.basis4,
      transition: 'color 0.2s, opacity 0.2s',
      justifyContent: 'center',
      display: 'flex',
      fontSmoothing: 'antialiased',
      lineHeight: '14px',
      '& svg': {
        fontSize: 12,
      },
      '& > *:not(:last-child)': {
        marginRight: 5,
      },
      '&.disabled': {
        opacity: 0.35,
        cursor: 'not-allowed !important',
      },
      '&:hover:not(.disabled)': {
        color: theme.color.basis3,
      },
      '&:not(:last-child)': {
        marginRight: 20,
      },
      '&.active': {
        color: theme.color.basis2,
        opacity: 1,
        ...cssUtils.hover({
          color: theme.color.basis1,
        }),
      },
      [theme.mediaQuery.mobileOnly]: {
        fontSize: 18,
        '& svg': {
          fontSize: 16,
        },
      },
    },
  };
}

export default useSheet(applyStyles)(GroupContainerCategoryItem);
